import { useState, useEffect, useRef, useMemo } from "react";
import * as THREE from "three";
import { useFrame, useThree } from "@react-three/fiber";
import { useTimer } from "use-timer";
import SceneThree from "./Background-scene/SceneThree";
import gsap from "gsap";
import { getRenderer } from "./WebGLRendererSingleton";


const LevelThree = ({
  data,
// worldPosition,
  setConfetti,
// setChangeBackground,
  Yay,
  halfY,
  nextClick,
  setNextClick,
}) => {
  const ref = useRef();
  const { time, start, pause, reset, status } = useTimer();
  const [spriteScale, setSpriteScale] = useState([0, 0, 0]);
  const [clickCurrect, setClickCurrent] = useState(undefined);
  const [click, setClick] = useState("");
  const [objectGifVisible, setObjectGifVisible] = useState(false);

  const [worldPosition, setWorldPosition] = useState();
  const [changeBackground, setChangeBackground] = useState('');
  const [intersectedObj, setIntersectedObj] = useState([]);
  const [checkDataChnaged, setCheckDataChanged] = useState(false);
  const [enableClick, setEnableClick] = useState(false);

  const { viewport: v, gl, scene } = useThree();

  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;

  const fov = 50;
  const planeAspectRatio = 16 / 9;

  const viewSize = 50;
  var camera = new THREE.OrthographicCamera();
  camera.aspect = width / height;

 

  const loader = new THREE.TextureLoader();

  // A png with transparency to use as the target object.
  const dt = data;

  // const textureA = useMemo(
  //   () => loader.load(dt[0]?.letterImg),
  //   [dt[0]?.letterImg]
  // );

  const textureA = useMemo(
    () =>
      loader.load(dt[0]?.letterImg, function (data) {
    
        // the rest of your code here...
        textureA.name = dt[0]?.mainLetter;
        textureA.colorSpace = THREE.SRGBColorSpace;
        textureA.minFilter = THREE.LinearFilter;
        var tex = textureA.clone();
     
        tex.needsUpdate = true;
      }),
    [dt[0]?.letterImg]
  );

  const textureB = useMemo(
    () =>
      loader.load(dt[1]?.letterImg, function (data) {
      
        textureB.needsUpdate = true;
        textureB.name = dt[1]?.mainLetter;
        textureB.colorSpace = THREE.SRGBColorSpace;
        textureB.minFilter = THREE.LinearFilter;
        var tex = textureB.clone();
       
        tex.needsUpdate = true;
      }),
    [dt[1]?.letterImg]
  );

  // var textureC = loader.load(dt[2]?.letterImg);
  const textureC = useMemo(
    () =>
      loader.load(dt[2]?.letterImg, function (data) {
      
        // the rest of your code here...

        textureC.name = dt[2]?.mainLetter;
        textureC.colorSpace = THREE.SRGBColorSpace;
        textureC.minFilter = THREE.LinearFilter;
        var tex = textureA.clone();
     
        tex.needsUpdate = true;
      }),
    [dt[2]?.letterImg]
  );

  const objectTexture = useMemo(
    () =>
      loader.load(dt[0]?.letterImg, function (data) {
      
        // the rest of your code here...

        objectTexture.name = dt[0]?.mainLetter;
        objectTexture.colorSpace = THREE.SRGBColorSpace;
        objectTexture.minFilter = THREE.LinearFilter;
        var tex = objectTexture.clone();
     
        tex.needsUpdate = true;
      }),
    [dt[0]?.objectImg]
  );

  // const objectTexture = useMemo(
  //   () => loader.load(dt[0]?.letterImg),
  //   [dt[0]?.objectImg]
  // );
  
  const nameTexture = useMemo(
    () =>
      loader.load(dt[0]?.nameImg, function (data) {
      
        // the rest of your code here...
        nameTexture.needsUpdate = true;
        nameTexture.name = dt[0]?.mainLetter;
        nameTexture.colorSpace = THREE.SRGBColorSpace;
        nameTexture.minFilter = THREE.LinearFilter;
        var tex = nameTexture.clone();
     
        tex.needsUpdate = true;
      }),
    [dt[0]?.nameImg]
  );

  // const nameTexture = useMemo(
  //   () => loader.load(dt[0]?.nameImg),
  //   [dt[0]?.nameImg]
  // );
  // nameTexture.needsUpdate = true;
  // nameTexture.colorSpace = THREE.SRGBColorSpace;
  // nameTexture.minFilter = THREE.LinearFilter;

  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  const [effectActive, setEffectActive] = useState(undefined);
  const [squareCame, setSquareCame] = useState(false);

  const [renderers, setrenderers] = useState([])

  function createRenderer() {
   
    if(renderers.length === 0) {
      const rendererr = getRenderer();
     
      setrenderers((prev) => [...prev, rendererr])
      return rendererr;
    }
    
  }

  
  let renderer;
  if(renderers.length === 0) {
    renderer = createRenderer()
  }

  renderer?.domElement?.addEventListener("webglcontextlost", (event) => {
    console.log("WebGL context lost", gl.info.memory);
    textureA.dispose();
    textureB.dispose();
    textureC.dispose();
    objectTexture.dispose();
    nameTexture.dispose();
    clearTexture();
    // setTimeout(() => {
    //   renderer?.forceContextRestore();
    // }, 1000);
    // Handle context lost situation here
  });

  // Listen for context restored event
  renderer?.domElement?.addEventListener("webglcontextrestored", (event) => {
    console.log("WebGL context restored");
    // Resources should be reloaded or recreated here
  });
 
 


  function useAspect(width, height, factor = 0.12) {
    const adaptedHeight =
      height * (aspect > width / height ? v.width / width : v.height / height);
    const adaptedWidth =
      width * (aspect > width / height ? v.width / width : v.height / height);
    return [adaptedWidth * factor, adaptedHeight * factor, 1];
  }

  const [aspectWidth, aspectHeight] = useAspect(
    window.innerWidth,
    window.innerHeight
  );
  const [currentWordData, setCurrentWordData] = useState({});
  var timeOut;

  

  useFrame(({ clock }) => {
    if (effectActive && status === "RUNNING") {
      const elapsedTime = clock.getElapsedTime();
      // Sine wave for continuous squash and stretch effect
      const scaleFactor = Math.sin(elapsedTime * 2) * 0.5 + 1.7;
      const stretchFactor = 1 / scaleFactor;
      const actualAlphabet = ref.current.children.filter(({ name }) =>
        data.some(
          (x) => x.mainLetter == name && name !== undefined && name !== ""
        )
      );
      // Apply squash and stretch by scaling on different axes
      //ref.current.children[0]?.scale.set(stretchFactor, scaleFactor, stretchFactor);
      actualAlphabet[0].scale.x = stretchFactor;
      actualAlphabet[0].scale.y = stretchFactor;
    } else if (!effectActive && status === "RUNNING") {
      const actualAlphabet = ref.current.children.filter(({ name }) =>
        data.some(
          (x) => x.mainLetter == name && name !== undefined && name !== ""
        )
      );
      actualAlphabet[0].scale.set(aspectWidth, aspectWidth, 1);
    }
  });

  useEffect(() => {
    setChangeBackground("ovals");
    if (dt.length > 0) {
      // ref.current.children[3].visible = false;
      setCurrentWordData(dt.filter((itm) => itm.mainLetter !== undefined));
    }
  }, [data]);

  useEffect(() => {
    // adjustSpriteSize();

    // window.addEventListener("resize", function (e) {
    //   adjustSpriteSize();
    //   const height = window.innerHeight;
    //   const aspect = width / height;
    //   camera.aspect = window.innerWidth / window.innerHeight;

    //   if (camera.aspect > planeAspectRatio) {
    //     // window too large
    //     const cameraHeight = Math.tan(MathUtils.degToRad(fov / 2));
    //     const ratio = camera.aspect / planeAspectRatio;
    //     const newCameraHeight = cameraHeight / ratio;
    //     camera.fov = MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
    //   } else {
    //     // window too narrow
    //     camera.fov = fov;
    //   }
    //   camera.updateProjectionMatrix();
    //   visibleWidthAtZDepth(camera.fov, camera);

    //   renderer?.setSize(width, height);
    // });
    return () => {
      // ref.current = null

      objectTexture.dispose();
      nameTexture.dispose();
      textureA.dispose();
      textureB.dispose();
      textureC.dispose();
      clearTexture()
    
      scene.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          if (Array.isArray(child.material)) {
            child.material.dispose();
          }
        }
        if (child instanceof THREE.Sprite) {
          child.geometry.dispose();
          if (Array.isArray(child.material)) {
            child.material.dispose();
          }
        }
      });
      console.log('renderer 274',renderer)
      if(renderer) {
        renderer?.dispose();
      }
      
    };
  }, []);

  var listener = new THREE.AudioListener();
  camera.add(listener);
  // create a global audio source
  var sound = new THREE.Audio(listener);

  var audioLoader = new THREE.AudioLoader();

  function disposeMaterialTextures(material) {
    const textureProps = [
      "map",
      "lightMap",
      "aoMap",
      "emissiveMap",
      "bumpMap",
      "normalMap",
      "displacementMap",
      "roughnessMap",
      "metalnessMap",
      "alphaMap",
      "envMap",
      "specularMap",
      "gradientMap",
    ];

    textureProps.forEach((prop) => {
      if (material[prop]) {
        material[prop].dispose();
        material[prop] = null;
      }
    });
  }

  function disposeObjectTextures(object) {
    if (object.material) {
      // object.dispose()
      object.material?.dispose();
      // disposeMaterialTextures(object.material);
    }
  }

  useEffect(() => {
    setCheckDataChanged(true);
    ref.current.children[0].visible = false;
    ref.current.children[1].visible = false;
    ref.current.children[2].visible = false;
    return () => {
      scene.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          if (Array.isArray(child.material)) {
            child.material?.dispose();
          }
        }
        if (child instanceof THREE.Sprite) {
          child.geometry.dispose();
        }
      });
    };
  }, [data]);

  useEffect(() => {
    if (checkDataChnaged) {
      // ref.current.children[3].position.set(1, 5.5, 1);

      // renderer?.forceContextLoss();

      // setTimeout(function () {
      //   renderer?.forceContextRestore();
      // }, 200);

      setEffectActive(undefined);
      pause();
      setClick("");
      setClickCurrent(undefined);

      setConfetti({ run: false, ratio: 0 });
      setIntersectedObj([]);

      setTimeout(() => {
        setSquareCame(false);
        console.log("webgl", gl.info.memory);

        if (
          ref.current &&
          worldPosition &&
          data.length > 0 &&
          !squareCame &&
          checkDataChnaged
        ) {
          if (ref.current.children?.length > 3) {
            ref.current.remove(ref.current.children[3]);

            ref.current.remove(ref.current.children[3]);
          }
          ref.current.children[1]?.scale.set(aspectWidth, aspectWidth, 1);
          ref.current.children[2]?.scale.set(aspectWidth, aspectWidth, 1);
          if (ref.current.children?.length > 3) {
            ref.current.remove(ref.current.children[3]);
            ref.current.remove(ref.current.children[3]);
          }

          arrangeObj();
        }
      }, 2000);
    }
  }, [worldPosition, checkDataChnaged]);

  useEffect(() => {
    return () => {
      // console.log("clear timeout")
      // clearTimeout(timeOut)
    };
  }, [checkDataChnaged]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (data?.length > 0 && ref.current.children?.length > 0) {
        // Perform actions after waiting for 3 seconds

        if (clickCurrect === undefined) {
          setEffectActive(true);
          start();
          if(sound.isPlaying) {
            sound.pause()
            sound.stop()
          }
          // renderer?.forceContextLoss();
          // setTimeout(function () {
          //   renderer?.forceContextRestore();
          // }, 300);
          setTimeout(() => {
            if(sound.isPlaying) {
              sound.pause()
              sound.stop()
            }
            setEffectActive(false);
            pause();
            setClick("none");
          }, 3000);


        }
      }
    }, 8000);

    return () => clearTimeout(timer);
  }, [clickCurrect]);

  useEffect(() => {
    const positionRight = worldPosition?.right;
    const positionLeft = worldPosition?.left;

    if (ref.current.children?.length > 0 && worldPosition && data.length > 0) {
      if ((effectActive === undefined || !effectActive) && click === "first") {
        pause();
        setEnableClick(false);
        setEffectActive(false);
        setClick("first");
        // renderer?.forceContextLoss();
        // setTimeout(function () {
        //   renderer?.forceContextRestore();
        // }, 200);

        const actualAlphabet = ref.current.children.filter(({ name }) =>
          data.some(
            (x) => x.mainLetter == name && name !== undefined && name !== ""
          )
        );

        timeOut = setTimeout(() => {
          const actualAlphabet = ref.current.children.filter(({ name }) =>
            data.some(
              (x) => x.mainLetter == name && name !== undefined && name !== ""
            )
          );
          const index = ref.current.children.indexOf(actualAlphabet[0]);
          const removeAlphabet = ref.current.children.filter(({ name }) =>
            data.some((x) => name === undefined || name === "")
          );
          removeAlphabet?.map((itm, index2) => {
            const j = ref.current.children.indexOf(itm);
            ref.current.children[j].visible = false;
          });
          gsap.to(ref.current.children[index]?.position, {
            //x: worldPosition.left.x + aspectWidth / 1.5, // + 0.8,
            x: positionLeft?.x + aspect / 3 + 0.15,
            y: worldPosition.left.y,
          });
          gsap.to(ref.current.children[index]?.scale, {
            x: aspectWidth,
            y: aspectWidth,
          });
          const spriteTexture = loader.load(data[index]?.objectImg);
          spriteTexture.name = data[index]?.mainLetter;
          spriteTexture.colorSpace = THREE.SRGBColorSpace;
          spriteTexture.minFilter = THREE.LinearFilter;

          const letterTexture = loader.load(data[index]?.nameImg);
          letterTexture.name = data[index]?.mainLetter;
          letterTexture.colorSpace = THREE.SRGBColorSpace;
          letterTexture.minFilter = THREE.LinearFilter;
          // Create a object material
          const objectMaterial = new THREE.SpriteMaterial({
            map: spriteTexture,
          });
          const letterMaterial = new THREE.SpriteMaterial({
            map: letterTexture,
          });
          // Create a object
          const object = new THREE.Sprite(objectMaterial);

          // object.visible = false;
          object?.position.set(
            worldPosition.right.x - aspect / 2,
            positionRight.y + aspectWidth / 2,
            1
          );

          const letterForScaleCond = data.filter(
            (rr) => rr.mainLetter !== "" && rr.mainLetter !== undefined
          )[0].letter;
        
          if (letterForScaleCond === "T" || letterForScaleCond === "Tr") {
            object?.scale.set(aspectWidth * 1.5, aspectWidth * 1.5, 1);
          } else {
            object?.scale.set(aspectWidth, aspectWidth, 1);
          }

          // ref.current.children[3].visible = true;
          // gsap.fromTo(
          //   ref.current.children[3]?.position,
          //   {
          //     x: 1,
          //     y: 5.5,
          //     z: 1,
          //   },
          //   {
          //     y: positionRight.y + aspectWidth / 1,
          //     x: worldPosition.right.x - aspect / 1,
          //     z: 1,
          //     duration: 2,
          //     delay: 2,
          //   }
          // );
          // ref.current.children[3]?.scale.set(aspectWidth, aspectWidth, 1);

          const lett = new THREE.Sprite(letterMaterial);
          // lett?.position.set(
          //   worldPosition.right.x - aspect / 2,
          //   -aspectWidth, // - 1.4,
          //   1
          // );
          lett?.position.set(
            worldPosition.right.x - aspect / 2,
            positionRight?.y - aspectWidth / 2,
            1
          );
          const wordCount = data.filter(
            (rr) => rr.mainLetter !== "" && rr.mainLetter !== undefined
          )[0].wordCount;
          var countScale;
          if (wordCount === 3) {
            countScale = aspectWidth * 0.9;
          } else if (wordCount === 4) {
            countScale = aspectWidth * 1.3;
          } else if (wordCount === 5) {
            countScale = aspectWidth * 1.3;
          } else if (wordCount === 6) {
            countScale = aspectWidth * 1.6;
          } else if (wordCount === 7) {
            countScale = aspectWidth * 2;
          } else if (wordCount === 8) {
            countScale = aspectWidth * 2.2;
          } else if (wordCount === 9) {
            countScale = aspectWidth * 2;
          } else if (wordCount === 10) {
            countScale = aspectWidth * 2.1;
          }
          lett?.scale.set(countScale, countScale, 1);

          setTimeout(() => {
            ref.current.add(object);
            setTimeout(() => {
              ref.current.add(lett);
              setTimeout(() => {
                pause();

                audioPlay(Yay);
                setTimeout(() => {
                  audioPlay(data[index].wordMusic);

                  setTimeout(() => {
                    if (nextClick < 2) {
                      if(renderer) {
                        renderer?.dispose();
                      }
                      
                    
                     
                      objectTexture.dispose();
                      nameTexture.dispose();
                      textureA.dispose();
                      textureB.dispose();
                      textureC.dispose();
                      scene.remove(object);
                      scene.remove(lett);
                      clearTexture();
                      setNextClick(nextClick + 1);
                     
                      setChangeBackground('')
                    } else if (nextClick === 2) {
                      console.log('renderer 574',renderer)
                      if(renderer) {
                        renderer?.dispose();
                      }
                     
                      clearTexture();
                      objectTexture.dispose();
                     
                      scene.remove(object);
                      scene.remove(lett);
                      nameTexture.dispose();
                      textureA.dispose();
                      textureB.dispose();
                      textureC.dispose();
                      setChangeBackground('')
                    }
                  }, 4000);
                }, 2000);
                setConfetti({ run: true, ratio: 1 });
                // setSquareCame(false)
              }, 2000);
            }, 2000);
          }, 2000);
        }, 2000);
      } else if (!effectActive && click === "second") {
        // renderer?.forceContextLoss();
        // setTimeout(function () {
        //   renderer?.forceContextRestore();
        // }, 200);

        setEnableClick(false);
        setTimeout(() => {
          setChangeBackground("square");
          setCheckDataChanged(false);
          setSquareCame(true);

          const actualAlphabet = ref.current.children?.filter(({ name }) =>
            data.some(
              (x) => x.mainLetter == name && name !== undefined && name !== ""
            )
          );
          const index = ref.current.children?.indexOf(actualAlphabet[0]);

          const removeAlphabet = ref.current.children?.filter(({ name }) =>
            data.some((x) => name === undefined || name === "")
          );
          removeAlphabet?.map((itm, index2) => {
            const j = ref.current.children?.indexOf(itm);
            ref.current.children[j].visible = false;
          });

          gsap.to(ref.current.children[index]?.position, {
            //x: worldPosition.left.x + ref.current.children[0].scale.x / 1.5, // + 0.8,
            x: positionLeft?.x + aspect / 3 + 0.15,
            y: worldPosition.left.y,
          });
          gsap.to(ref.current.children[index]?.scale, {
            x: aspectWidth,
            y: aspectWidth,
          });
          const spriteTexture = loader.load(data[index]?.objectImg);
          spriteTexture.name = data[index]?.mainLetter;
          spriteTexture.colorSpace = THREE.SRGBColorSpace;
          spriteTexture.minFilter = THREE.LinearFilter;

          const letterTexture = loader.load(data[index]?.nameImg);
          letterTexture.name = data[index]?.mainLetter;
          letterTexture.colorSpace = THREE.SRGBColorSpace;
          letterTexture.minFilter = THREE.LinearFilter;
          // Create a object material
          const objectMaterial = new THREE.SpriteMaterial({
            map: spriteTexture,
          });
          const letterMaterial = new THREE.SpriteMaterial({
            map: letterTexture,
          });
          // Create a object
          const object = new THREE.Sprite(objectMaterial);
          // object?.position.set(
          //   worldPosition.right.x - aspect / 2,
          //   aspectWidth, // worldPosition.right.y, // + aspectWidth / 2,
          //   1
          // );
          // object.visible = false;
          object?.position.set(
            worldPosition.right.x - aspect / 2,
            positionRight.y + aspectWidth / 2,
            1
          );
          const letterForScaleCond = data.filter(
            (rr) => rr.mainLetter !== "" && rr.mainLetter !== undefined
          )[0].letter;
          if (letterForScaleCond === "T" || letterForScaleCond === "Tr") {
            object?.scale.set(aspectWidth * 1.5, aspectWidth * 1.5, 1);
          } else {
            object?.scale.set(aspectWidth, aspectWidth, 1);
          }

          const lett = new THREE.Sprite(letterMaterial);

          lett?.position.set(
            worldPosition.right.x - aspect / 2,
            positionRight?.y - aspectWidth / 2,
            1
          );
          const wordCount = data.filter(
            (rr) => rr.mainLetter !== "" && rr.mainLetter !== undefined
          )[0].wordCount;
          let countScale;
          if (wordCount === 3) {
            countScale = aspectWidth * 0.9;
          } else if (wordCount === 4) {
            countScale = aspectWidth * 1.3;
          } else if (wordCount === 5) {
            countScale = aspectWidth * 1.3;
          } else if (wordCount === 6) {
            countScale = aspectWidth * 1.6;
          } else if (wordCount === 7) {
            countScale = aspectWidth * 2;
          } else if (wordCount === 8) {
            countScale = aspectWidth * 2.2;
          } else if (wordCount === 9) {
            countScale = aspectWidth * 2;
          } else if (wordCount === 10) {
            countScale = aspectWidth * 2.1;
          }

          lett?.scale.set(countScale, countScale, 1);
          ref.current.children[0]?.scale.set(aspectWidth, aspectWidth, 1);
          timeOut = setTimeout(() => {
            ref.current.add(object);
            setTimeout(() => {
              ref.current.add(lett);
              audioPlay(halfY);
              setTimeout(() => {
                audioPlay(data[index].wordMusic);
                setTimeout(() => {
                  if (nextClick < 2) {
                    console.log('renderer 711',renderer)
                    if(renderer) {
                      renderer?.dispose();
                    }
                   
                  
                    objectTexture.dispose();
                    nameTexture.dispose();
                    textureA.dispose();
                    textureB.dispose();
                    textureC.dispose();
                    scene.remove(object);
                    scene.remove(lett);
                    clearTexture();
                    setNextClick(nextClick + 1);
                    setChangeBackground('')
                  } else if (nextClick === 2) {
                    console.log('renderer 726',renderer)
                    if(renderer) {
                      renderer?.dispose();
                    }
                    
                   
                   
                    clearTexture();
                    objectTexture.dispose();
                    nameTexture.dispose();
                    textureA.dispose();
                    textureB.dispose();
                    textureC.dispose();
                    scene.remove(object);
                    scene.remove(lett);
                    setNextClick(nextClick + 1);
                  } 
                }, 4000);
              }, 2000);
              setConfetti({ run: true, ratio: 0.3 });
            }, 2000);
          }, 2000);

          // setSquareCame(false)
        }, 2000);
      } else if (
        !effectActive &&
        effectActive !== undefined &&
        clickCurrect === undefined &&
        click === "none"
      ) {
        setEnableClick(false);
        // renderer?.forceContextLoss();
        // setTimeout(function () {
        //   renderer?.forceContextRestore();
        // }, 200);

        timeOut = setTimeout(() => {
          setChangeBackground("square");
          setCheckDataChanged(false);
          setSquareCame(true);

          const actualAlphabet = ref.current.children?.filter(({ name }) =>
            data.some(
              (x) => x.mainLetter == name && name !== undefined && name !== ""
            )
          );
          const index = ref.current.children?.indexOf(actualAlphabet[0]);

          const removeAlphabet = ref.current.children?.filter(({ name }) =>
            data.some((x) => name === undefined || name === "")
          );
          removeAlphabet?.map((itm, index2) => {
            const j = ref.current.children?.indexOf(itm);
            ref.current.children[j].visible = false;
          });

          gsap.to(ref.current.children[index]?.position, {
            // x: worldPosition.left.x + ref.current.children[0].scale.x / 1.5, // + 0.8,
            x: positionLeft?.x + aspect / 3 + 0.15,
            y: worldPosition.left.y,
          });
          gsap.to(ref.current.children[index]?.scale, {
            x: aspectWidth,
            y: aspectWidth,
          });
          const spriteTexture = loader.load(data[index]?.objectImg);
          spriteTexture.name = data[index]?.mainLetter;
          spriteTexture.colorSpace = THREE.SRGBColorSpace;
          spriteTexture.minFilter = THREE.LinearFilter;

          const letterTexture = loader.load(data[index]?.nameImg);
          letterTexture.name = data[index]?.mainLetter;
          letterTexture.colorSpace = THREE.SRGBColorSpace;
          letterTexture.minFilter = THREE.LinearFilter;
          // Create a object material
          const objectMaterial = new THREE.SpriteMaterial({
            map: spriteTexture,
          });
          const letterMaterial = new THREE.SpriteMaterial({
            map: letterTexture,
          });
          // Create a object
          const object = new THREE.Sprite(objectMaterial);
          // object?.position.set(
          //   worldPosition.right.x - aspect / 2,
          //   aspectWidth, // worldPosition.right.y, // + aspectWidth / 2,
          //   1
          // );
          // object.visible = false;
          object?.position.set(
            worldPosition.right.x - aspect / 2,
            positionRight.y + aspectWidth / 2,
            1
          );
          const letterForScaleCond = data.filter(
            (rr) => rr.mainLetter !== "" && rr.mainLetter !== undefined
          )[0].letter;
          if (letterForScaleCond === "T" || letterForScaleCond === "Tr") {
            object?.scale.set(aspectWidth * 1.5, aspectWidth * 1.5, 1);
          } else {
            object?.scale.set(aspectWidth, aspectWidth, 1);
          }

          // ref.current.children[3].visible = true;
          // gsap.fromTo(
          //   ref.current.children[3]?.position,
          //   {
          //     x: 1,
          //     y: 5.5,
          //     z: 1,
          //   },
          //   {
          //     y: positionRight.y + aspectWidth / 1,
          //     x: worldPosition.right.x - aspect / 1,
          //     z: 1,
          //     duration: 2,
          //     delay: 2,
          //   }
          // );
          // // ref.current.children[3]?.position.set(
          // //   worldPosition.right.x - aspect / 2,
          // //   positionRight.y + aspectWidth / 2,
          // //   1
          // // );
          // ref.current.children[3]?.scale.set(aspectWidth, aspectWidth, 1);

          const lett = new THREE.Sprite(letterMaterial);
          // lett?.position.set(
          //   worldPosition.right.x - aspect / 2,
          //   -aspectWidth, // worldPosition.right.y, // - 1.4,
          //   1
          // );
          lett?.position.set(
            worldPosition.right.x - aspect / 2,
            positionRight?.y - aspectWidth / 2,
            1
          );
          const wordCount = data.filter(
            (rr) => rr.mainLetter !== "" && rr.mainLetter !== undefined
          )[0].wordCount;
          let countScale;
          if (wordCount === 3) {
            countScale = aspectWidth * 0.9;
          } else if (wordCount === 4) {
            countScale = aspectWidth * 1.3;
          } else if (wordCount === 5) {
            countScale = aspectWidth * 1.3;
          } else if (wordCount === 6) {
            countScale = aspectWidth * 1.6;
          } else if (wordCount === 7) {
            countScale = aspectWidth * 2;
          } else if (wordCount === 8) {
            countScale = aspectWidth * 2.2;
          } else if (wordCount === 9) {
            countScale = aspectWidth * 2;
          } else if (wordCount === 10) {
            countScale = aspectWidth * 2.1;
          }

          lett?.scale.set(countScale, countScale, 1);
          ref.current.children[0]?.scale.set(aspectWidth, aspectWidth, 1);
          setTimeout(() => {
            ref.current.add(object);
            setTimeout(() => {
              ref.current.add(lett);
              audioPlay(data[index].wordMusic);
              setTimeout(() => {
                if (nextClick < 2) {
                  console.log('renderer 895',renderer)
                  if(renderer) {
                    renderer?.dispose();
                  }
                 
                  scene.remove(object);
                  scene.remove(lett);
                  objectTexture.dispose();
                  nameTexture.dispose();
                  textureA.dispose();
                  textureB.dispose();
                  textureC.dispose();
                  clearTexture()
                  setNextClick(nextClick + 1);
                  setChangeBackground('')
                } else if (nextClick === 2) {
                  console.log('renderer 909',renderer)
                  if(renderer) {
                    renderer?.dispose();
                  }
                  
                  scene.remove(object);
                  scene.remove(lett);
                  clearTexture();
                  objectTexture.dispose();
                  nameTexture.dispose();
                  textureA.dispose();
                  textureB.dispose();
                  textureC.dispose();
                  setChangeBackground('')
                }
              }, 4000);
            }, 2000);
          }, 2000);

          // setEffectActive(false);

          // setSquareCame(false)
        }, 2000);
      }
    }
  }, [click, effectActive]);

  function onMouseClick(event, name) {
    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }
    if (enableClick) {
      // Calculate mouse position in normalized device coordinates (-1 to +1)
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      // Update the picking ray with the camera and mouse position
      raycaster.setFromCamera(mouse, camera);

      // renderer?.forceContextLoss();
      // setTimeout(function () {
      //   renderer?.forceContextRestore();
      // }, 200);

      // // Calculate objects intersecting the picking ray
      // working rightly
      var vector = new THREE.Vector3(
        (event.clientX / window.innerWidth) * 2 - 1,
        -(event.clientY / window.innerHeight) * 2 + 1,
        0.5
      );
      var raycasterr = new THREE.Raycaster(
        camera?.position,
        vector.sub(camera?.position).normalize()
      );
      raycasterr.setFromCamera(vector, camera);
      // alternative
      var intersectss = intersectedObj?.filter(
        (itm) => itm.name === name && itm.name !== "" && itm.name !== undefined
      );
      for (let i = 0; i < intersectss.length; i++) {
        const intersectedObject = intersectss[0];
        setSquareCame(true);
        setCheckDataChanged(false);
        setChangeBackground("square");

        pause();
        setEffectActive(false);
        setClickCurrent(true);
        if (effectActive) {
          setClick("second");
        } else if (effectActive === undefined) {
          setClick("first");
        }

        // clickCurrect = true

        // setTimeout(() => {

        setTimeout(() => {
          document.body.style.cursor = "pointer";
          // Perform any actions with the intersected object
          pause();
          // gsap.to(intersectedObject?.scale, {
          //   x: intersectedObject?.scale.x + aspect / 3,
          //   y: intersectedObject?.scale.y + aspect / 3,
          //   onComplete: () => {
          //     gsap.to(intersectedObject?.scale, {
          //       x: aspectWidth,
          //       y: aspectWidth,
          //       delay: 2,
          //       onComplete: () => {
          //         pause();

          //         // if (clickCurrect !== false) {
          //         //   audioPlay(Yay);
          //         //   setTimeout(() => {
          //         //     // audioPlay(data[index].wordMusic);
          //         //   }, 2000);
          //         //   setConfetti({ run: true, ratio: 1 });
          //         // }
          //       },
          //     });
          //   },
          // });
        }, 1000);
      }
    }
  }

  function adjustSpriteSize() {
    // Get the screen dimensions
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Define a base size for the object
    const baseWidth = 550; // Adjust this value as needed
    const baseHeight = 550; // Adjust this value as needed

    // Calculate the scale factors
    const scaleX = screenWidth / baseWidth;
    const scaleY = screenHeight / baseHeight;

    setSpriteScale([scaleX, scaleY, 0]);
  }

 

  function audioPlay(name) {
    // renderer?.forceContextLoss();
    // setTimeout(function () {
    //   renderer?.forceContextRestore();
    // }, 200);
    //Load a sound and set it as the Audio object's buffer

    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }

    audioLoader.load(`${name}`, function (buffer) {
      sound.setBuffer(buffer);
      sound.stop();
      sound.setLoop(false);
      sound.setVolume(1);
      sound.play();
    });
  }

  const visibleHeightAtZDepth = (depth, camera) => {
    // compensate for cameras not positioned at z=0
    const cameraOffset = camera?.position.z;
    if (depth < cameraOffset) depth -= cameraOffset;
    else depth += cameraOffset;

    // vertical fov in radians
    const vFOV = (camera.fov * Math.PI) / 180;

    // Math.abs to ensure the result is always positive
    return 2 * Math.tan(vFOV / 2) * Math.abs(depth);
  };

  const visibleWidthAtZDepth = (depth, camera) => {
    const height = visibleHeightAtZDepth(depth, camera);

    return height * camera.aspect;
  };

  useFrame((state) => {
    // ref.current.children[0]?.scale.x = Math.sin(state.clock.getElapsedTime()) + 1
    // ref.current.children[0]?.scale.y = Math.sin(state.clock.getElapsedTime()) + 1
    // ref.current.children[0]?.scale.z = Math.sin(state.clock.getElapsedTime() /3)
  });

  function arrangeObj() {
    if (ref.current.children?.length > 3) {
      ref.current.remove(ref.current.children[3]);

      ref.current.remove(ref.current.children[3]);
    }

    ref.current.children[0].visible = true;
    ref.current.children[1].visible = true;
    ref.current.children[2].visible = true;

    // renderer?.forceContextLoss();
    // setTimeout(function () {
    //   renderer?.forceContextRestore();
    // }, 200);

    // ref.current.children[3].position.set(1, 6, 1);

    const positionLeft = worldPosition.left; // new THREE.Vector3({x: 1,y:0, z:0});
    const positionMiddle = worldPosition.middle;
    const positionRight = worldPosition.right; // new THREE.Vector3({x: -1, y:0, z:0});
    // letter
    gsap.fromTo(
      ref.current.children[0]?.position,
      {
        y: 4, // 4,
        x: positionLeft.x + aspectWidth / 2.2, //positionLeft.x + ref.current.children[0].scale.x / 1.5, //+ 0.8,
        z: 1,
      },
      {
        y: positionLeft.y,
        duration: 2,
        onComplete: () => {
          if (
            ref.current.children[0]?.name !== "" &&
            ref.current.children[0]?.name !== undefined
          ) {
            audioPlay(dt[0].music);
          }
        },
      }
    );

    gsap.fromTo(
      ref.current.children[1]?.position,
      {
        y: 4, // 4,
        x: positionMiddle?.x,
        z: 1,
      },
      {
        y: positionMiddle.y - aspectWidth / 4.7,
        duration: 2,
        onComplete: () => {
          if (
            ref.current.children[1]?.name !== "" &&
            ref.current.children[1]?.name !== undefined
          ) {
            audioPlay(dt[1].music);
          }
        },
      }
    );
    gsap.fromTo(
      ref.current.children[2]?.position,
      {
        y: 4, // 4,
        x: positionRight.x - aspectWidth / 2.2, // - 1,
        z: 1,
      },
      {
        y: positionRight.y,
        duration: 2,
        onComplete: () => {
          if (
            ref.current.children[2]?.name !== "" &&
            ref.current.children[2]?.name !== undefined
          ) {
            audioPlay(dt[2].music);
          }
        },
      }
    );
    setEnableClick(true);
    setIntersectedObj(ref.current.children);

    // setIntersectedObj([ref.current.children[0], ref.current.children[1], ref.current.children[2]])
  }

  // const clearTexture = () => {
  //   scene.traverse(function (child) {
  //     if (child instanceof THREE.Mesh) {
  //       child.geometry.dispose();
  //       if (Array.isArray(child.material)) {
  //         child.material?.dispose();
  //       }
  //       // if (Array.isArray(child.material)) {
  //       //   child.material.forEach(disposeResource);
  //       // } else {
  //       //   disposeResource(child.material);
  //       // }
  //     }
  //     if (child instanceof THREE.Sprite) {
  //       child.geometry.dispose();
  //       if (Array.isArray(child.material)) {
  //         child.material?.dispose();
  //       }
  //       // if (Array.isArray(child.material)) {
  //       //   child.material.forEach(disposeResource);
  //       // } else {
  //       //   disposeResource(child.material);
  //       // }
  //     }
  //     if (child instanceof THREE.Group) {
  //       child.traverse(function (nestedChild) {
  //         // if (nestedChild instanceof THREE.Mesh) {
  //         //   nestedChild.geometry.dispose();
  //         //   nestedChild.material?.dispose();
  //         // }
  //         // if (nestedChild instanceof THREE.Sprite) {
  //         //   nestedChild.geometry.dispose();
  //         //   nestedChild.material?.dispose();
  //         // }
  //         // if (Array.isArray(nestedChild.material)) {
  //         //   nestedChild.material.forEach(disposeResource);
  //         // } else {
  //         //   disposeResource(nestedChild.material);
  //         // }
  //       });
  //     }
  //   });
  // };

  const clearTexture = () => {
    scene.traverse(function (child) {
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();
        if (child.material.isMaterial) {
          child.material?.dispose();
        }
      }
      if (child instanceof THREE.Sprite) {
        // console.log(child)
        const disposeMaterial = (material) => {
          Object.getOwnPropertyNames(material).forEach((property) => {
            if (property === "isMaterial") {
              
              const materialProperty = material[property];
            
              if (materialProperty !== undefined) {
                var texture = material.map;
                var image = texture.source.data;
                
                if (image instanceof Image) {
                  console.log("dispose imagebtmap");
                  image = null;
                } else {
                  console.log("dispose image");
                  texture.image = null;
                }
                texture.dispose();
              }
            }
          });
          
          // material?.dispose();
        };
        if (child?.material !== undefined) {
          disposeMaterial(child.material);

        }

        child?.geometry.dispose();
        // if (Array.isArray(child.material)) {
        //   child.material?.dispose();
        // }
      }
      if (child instanceof THREE.Group) {
        child.traverse(function (nestedChild) {
          // if (nestedChild instanceof THREE.Mesh) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material?.dispose();
          // }
          // if (nestedChild instanceof THREE.Sprite) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material?.dispose();
          // }
        });
      }
    });
  };

  return (
    <>
      <SceneThree
        level={3}
        changeBackground={changeBackground}
        setWorldPosition={setWorldPosition}
      />
      <group ref={ref}  >
        <mesh

          name={dt[0]?.mainLetter !== "" ? dt[0]?.mainLetter : ""}
          scale={[aspectWidth, aspectWidth, 1]}
          onClick={(e) => {
            onMouseClick(e, dt[0]?.mainLetter);
          }}

        >

          <sprite isSprite={true}>
            <spriteMaterial

              attach="material"
              map={textureA}
              precision={'lowp'}
            // precision={"lowp"}
            />
          </sprite>
        </mesh>
        <mesh
          name={dt[1]?.mainLetter !== "" ? dt[1]?.mainLetter : ""}
          scale={[aspectWidth, aspectWidth, 1]}
          onClick={(e) => {
            onMouseClick(e, dt[1]?.mainLetter);
          }}
        >
          <sprite isSprite={true}  >
            <spriteMaterial

              attach="material"
              map={textureB}
              precision={'lowp'}
            // precision={"lowp"}
            />
          </sprite>
        </mesh>
        <mesh
          name={dt[2]?.mainLetter !== "" ? dt[2]?.mainLetter : ""}
          scale={[aspectWidth, aspectWidth, 1]}
          onClick={(e) => {
            onMouseClick(e, dt[2]?.mainLetter);
          }}
        >
          <sprite isSprite={true}  >
            <spriteMaterial

              attach="material"
              map={textureC}
              precision={'lowp'}
            // precision={"lowp"}
            />
          </sprite>
        </mesh>
      </group>
    </>
  );
};

export default LevelThree;
